// App.js
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import HomePage from './components/HomePage';
import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import BlogPostPage from './components/BlogPostPage';
import LoginRegister from './components/LoginRegister';
import MyDownloads from './components/MyDownloads';
import ProductReview from './components/ProductReview';
import ContactUs from './components/ContactUs';
import WebReader from './components/WebReader';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductList />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/login" element={<LoginRegister mode="login" />} />
            <Route path="/register" element={<LoginRegister mode="register" />} />
            <Route path="/my-downloads" element={<MyDownloads />} />
            <Route path="/read/:token" element={<WebReader />} />
            <Route path="/review/:token" element={<ProductReview />} />
            <Route path="/products/:productId/write-review" element={<ProductReview />} />
            <Route path="/contact" element={<ContactUs />} />
          </Routes>
        </main>
      </AuthProvider>
    </Router>
  );
}

export default App;
